<!--transcript:单科报告 - 校级报告- 成绩单 2024/09/22 17:31:10 YuAng-->

<template>
  <div class="grade-transcript">
    <div class="wrapper">
      <div class="header-wrap">
        <div>
          <el-popover placement="right-start" trigger="click">
            <ul class="class-list" style="max-width: 90vw;">
              <li v-for="(item, index) in classLists" :key="index">
                <el-button @click="_chosenClass(item)" :type="item.selected ? 'primary' : 'info'" size="small">{{ item.gradeName }}{{ item.className }}</el-button>
              </li>
            </ul>
            <el-button type="primary" size="small" slot="reference">全部班级</el-button>
          </el-popover>
          <search-bar v-model="keyword" placeholder="搜索(姓名)" @keyup.enter.native="_searchStudentList()" @search="_searchStudentList()" style="margin-left: 24px;"></search-bar>
        </div>
        <!-- 区域联考不能显示 && 不能为拆分考试 -->
        <el-button type="primary" size="small" slot="reference" v-if="examInfo.isMore !== 2 && isExamSplit!==1" @click="showExportPaper">导出原卷</el-button>
      </div>

      <div class="card-content">
        <el-table :data="studentList" size="medium" v-loading="studentLoading" element-loading-text="年级学生较多，加载时间可能较长，请耐心等待" element-loading-spinner="el-icon-loading" max-height="600" border @sort-change="customSort" style="width: 100%;min-height: 220px">
          <el-table-column align="center" label="姓名">
            <template slot-scope="scope">
              <span v-html="studentNameKeyword(scope.row.studentName, keyword)"></span>
            </template>
          </el-table-column>
          <el-table-column width="150" v-if="reportType == 1" prop="teachClassName" align="center" sortable label="班级(教学班)"></el-table-column>
          <el-table-column width="150" align="center" prop="className" sortable :label="reportType == 1 ? '班级(行政班)' : '班级'"></el-table-column>

          <el-table-column width="120" prop="studentNo" align="center" sortable label="学号"> </el-table-column>
          <el-table-column width="150" prop="score" align="center" sortable label="得分(客/主)">
            <template slot-scope="scope">
              <span v-if="scope.row.scoreFlag" style="color: red">
                {{ scope.row.type === 0 ? '(不参与)' : '' }} {{ scope.row.score }} {{ scope.row.scoreFlag }}
              </span>
              <span v-else>{{ scope.row.type === 0 ? '(不参与)' : '' }}
                {{ scope.row.score < 0 ? (scope.row.score == -1 ? '--' : '未上传') : scope.row.score }}</span>
            </template>
          </el-table-column>
          <template v-if="showRanking">
            <el-table-column prop="classRanking" align="center" sortable label="班次">
              <template slot-scope="scope">
                <span>{{ scope.row.classRanking < 0 ? (scope.row.classRanking == -1 ? '--' : '未上传') : scope.row.classRanking }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="gradeRanking" align="center" sortable label="级次">
              <template slot-scope="scope">
                <span>{{ scope.row.gradeRanking < 0 ? (scope.row.gradeRanking == -1 ? '--' : '未上传') : scope.row.gradeRanking }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column align="center" fixed="right" label="分析报告">
            <template slot-scope="scope">
              <el-button size="mini" class="link-btn" type="text" @click="locationTo('/exam/single/report/class/transcript/', scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination" v-show="pageInfo.total">
          <yue-pagination @current-change="handleCurrentChange" :page="pageInfo"></yue-pagination>
        </div>
      </div>
    </div>
    <!-- 成绩单导出原卷 -->
    <export-paper ref="exportPaper" :examId="examId" :examInfo="examInfo"> </export-paper>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SearchBar from '@/components/common/SearchBar'
import { reportApi } from '@/v2/utils/api'
import util from '@/v2/utils/util'

let studentListAll = [] // 学生成绩单数据
let studentListNow = [] // 当前需要展示的学生成绩单

export default {
  props: ['gradeId', 'gradeName', 'classList', 'className', 'examInfo', 'reportType', 'branch', 'isExamSplit'],
  components: {
    ExportPaper: () => import('@/pages/exam/components/exportPaper.vue'),
    SearchBar,
  },
  data () {
    return {
      examId: this.$route.params.id,
      schoolId: '',
      keyword: '',
      // 年级题型得分情况
      studentSwitch: false,
      studentList: [], // 当前显示的数据
      studentListAll: [], // 源数据
      studentLoading: false,
      rightTableHeight: 600,
      isActive: false,
      keyWords: '',
      classLists: [],
      pageInfo: {
        total: 0,
        size: 100,
        current: 1
      },
      showRanking: true,
    }
  },

  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo'
    })
  },

  watch: {
    reportType (nVal, oVal) {
      if (nVal === oVal) return
      this._initFunc()
    },
  },

  mounted () {
    this.schoolId = this.userInfo.schoolId
    this.$nextTick(() => {
      this.rightTableHeight = document.body.offsetHeight - 60
    })
    this._initFunc()
  },

  methods: {
    // 导出原卷
    showExportPaper () {
      this.$refs.exportPaper.setIsShow(true, 'single')
    },
    _initFunc () {
      let params = {
        schoolId: this.schoolId,
        subjectCode: this.examInfo.subjectCode,
        isTeacher: true
      }

      reportApi.getShowRanking(params).then(resp => {
        if (resp.success) {
          this.showRanking = resp.body
          this._setClassList()
          this._getGradeStudentRakingList()
        }
      })
    },

    _setClassList () {
      if (Array.isArray(this.classList)) {
        let classLists = [{ id: 0, className: '全部班级', selected: true }]

        for (let item of this.classList) {
          let obj = { id: item.id, className: `${item.className}${item.hasData ? '' : '(未扫描)'}`, selected: true }
          classLists.push(obj)
        }
        this.classLists = classLists
      }
    },

    studentNameKeyword (val, keyword) {
      return val.replace(keyword, "<i style='color: red'>" + keyword + '</i>')
    },

    async _getGradeStudentRakingList () {
      this.studentLoading = true

      let params = {
        examId: this.examId,
        schoolId: this.schoolId,
        isTeachClass: this.reportType === 1
      }

      let resp = await reportApi.studentRanking(params)

      if (resp.success) {
        for (let item of resp.body) {
          if (isNaN(parseFloat(item.classRanking))) {
            item.classRanking = item.classRanking == '--' ? -1 : -2
          } else {
            item.classRanking = parseFloat(item.classRanking)
          }

          if (isNaN(parseFloat(item.gradeRanking))) {
            item.gradeRanking = item.gradeRanking == '--' ? -1 : -2
          } else {
            item.gradeRanking = parseFloat(item.gradeRanking)
          }
        }

        studentListAll = resp.body
        studentListNow = studentListAll
        this._setNowStudentList(studentListNow)

        this.$nextTick(() => {
          this.studentLoading = false
        })
      } else {
        this.studentLoading = false
      }
    },

    handleCurrentChange (val) {
      this.pageInfo.current = val
      this._setNowStudentList()
    },

    // 分页显示学生
    _setNowStudentList () {
      this.pageInfo.total = studentListNow.length

      let idx = 0
      let studentList = []
      for (let item of studentListNow) {
        idx++

        if (idx > (this.pageInfo.current - 1) * 100 && idx <= this.pageInfo.current * 100) {
          studentList.push(item)
        } else if (idx > (this.pageInfo.current + 1) * 100) {
          break
        }
      }

      this.studentList = studentList
    },

    // 搜索姓名关键字
    _searchStudentList () {
      // 重置当前页
      this.pageInfo.current = 1

      let studentList = []
      for (let item of studentListAll) {
        if (item.studentName.indexOf(this.keyword) > -1) {
          studentList.push(item)
        }
      }

      studentListNow = studentList

      this._setNowStudentList()
    },

    // 选择班级
    _chosenClass (obj) {
      if (obj.id == 0 && obj.selected) {
        obj.selected = false
        this.classLists.filter((item) => {
          item.selected = false
        })
      } else if (obj.id == 0) {
        obj.selected = true
        this.classLists.filter((item) => {
          item.selected = true
        })
      }

      if (obj.id !== 0) {
        obj.selected = !obj.selected

        let count = 0
        for (let item of this.classLists) {
          if (item.id === 0) continue
          if (item.selected === false) {
            count++
          }
        }

        if (count === 0) {
          this.classLists[0].selected = true
        } else {
          this.classLists[0].selected = false
        }
      }

      this.setCompareData()
    },

    // 基础指标对比分析根据班级筛选数据
    setCompareData () {
      this.pageInfo.current = 1

      let studentList = []
      for (let item of studentListAll) {
        for (let li of this.classLists) {
          if (this.reportType == 0) {
            if (item.className === li.className && li.selected) {
              studentList.push(item)
            }
          } else {
            if (item.teachClassName === li.className && li.selected) {
              studentList.push(item)
            }
          }
        }
      }

      studentListNow = studentList
      this._setNowStudentList()
    },

    locationTo (url, item) {
      if (util.isEmpty(item.score)) {
        this.$message.warning('暂无报告')
        return false
      } else {
        let className = '&className=' + item.className
        this.$router.push({
          path: url + this.examId + '/' + item.classId + '/' + item.studentId + '?name=' + item.studentName + '&examResultId=' + item.examResultId + '&reportType=' + this.reportType + className
        })
      }
    },

    customSort (data) {
      let prop = data.prop
      let order = data.order == 'ascending' ? 1 : 0
      studentListNow.sort(this.sortData(prop, order))
      this.pageInfo.current = 1
      this._setNowStudentList()
    },

    //自定义排序
    sortData (property, order) {
      return function (obj1, obj2) {
        let value1 = obj1[property]
        let value2 = obj2[property]
        if (order) {
          //1升序0降序
          return value1 - value2 //升序
        } else {
          return value2 - value1 //降序
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.grade-transcript {
  flex: 1;
  width: 0;
  box-sizing: border-box;
  .wrapper {
    flex: 1;
    box-sizing: border-box;
    margin-top: 14px;
    background: white;
    .card {
      flex: 1;
      border-radius: 4px;
      background: #fff;
      box-shadow: $box-shadow;
      padding-bottom: 10px;
      margin-bottom: 20px;
      > h3 {
        padding: 0 10px;
        height: 40px;
        line-height: 44px;
        font-size: 16px;
        color: $color-text;
        &:before {
          margin-top: -4px;
          display: inline-block;
          content: "";
          width: 4px;
          height: 20px;
          vertical-align: middle;
          background: $color-theme;
          border-radius: 10px;
          margin-right: 10px;
        }
        span {
          padding-left: 20px;
          font-size: $font-size-small;
          color: #aaa;
        }

        .button-group {
          display: inline-block;
          // float: right;
        }
      }
      .card-content {
        background: #fff;
        padding: 10px 35px 20px;
        .card-button {
          display: flex;
          justify-content: center;
          .el-button-group .el-button:first-child {
            border-radius: 20px 0 0 20px;
          }
          .el-button-group .el-button:last-child {
            border-radius: 0 20px 20px 0;
          }
        }
        .inner {
          padding-top: 20px;
          min-height: 325px;
          box-sizing: border-box;
          .more-data {
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
          }
        }
      }
    }
  }
  .header-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 10px 0 10px;
    margin-bottom: 14px;

    .classes-sel {
      display: flex;
      border: 1px solid #ddd7cf;
      padding: 0px 20px;
      height: 35px;
      line-height: 35px;
      background: #fff;
      ul {
        margin: 0;
        padding: 0;
        white-space: nowrap;
        li {
          display: inline-block;
          margin-left: 10px;
          border-right: 1px dashed #3a84d8;
          span {
            display: block;
            height: 25px;
            line-height: 25px;
            padding-left: 10px;
            padding-right: 10px;
            margin-right: 10px;
            border-radius: 2px;
            cursor: pointer;
          }
          .active {
            background: #3a84d8;
            color: white;
          }
        }
        &:last-child() li {
          border: none;
        }
      }
      .left_arrow {
        width: 8px;
        background: url("~images/left_arrow.png") center no-repeat;
        cursor: pointer;
      }
      .right_arrow {
        width: 8px;
        background: url("~images/right_arrow.png") center no-repeat;
        cursor: pointer;
      }
      .to-right {
        // float:right;
      }
    }
  }

  /*弹出*/
  .dilogSelectModel {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    height: 100%;
    overflow: auto;
    width: 100%;
    transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
    .content-body {
      background-color: #ffffff;
      width: 30%;
      float: right;
      height: 100%;
      border-left: 1px solid #f3f4f5;
      h4 {
        height: 60px;
        line-height: 60px;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
      }
    }
  }
  .slide-left-enter,
  .slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(100px, 0);
    transform: translate(100px, 0);
  }
  .slide-left-leave-active,
  .slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(100px, 0);
    transform: translate(100px, 0);
  }
}

.more-data {
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 14px;
  border: 1px solid #ebeef5;
  background: #fff;
  border-top: none;
  cursor: pointer;
  &:hover {
    color: $color-theme;
    background: #f5f7fa;
  }
}

.class-list {
  > li {
    float: left;
    margin: 0 0 6px 0;
    width: 90px;
    margin-left: 10px;
    .el-button {
      display: inline-block;
      width: 90px;
    }
  }
}

.card-content {
  background: #fff;
  padding: 10px 10px 20px;
  margin-bottom: 20px;
}

.pagination {
  text-align: right;
  padding: 10px 0 20px;
  .el-pagination {
    padding-right: 0;
  }
}
</style>
